module.exports = __webpack_public_path__ + "static/data-video-image-51ebcb4f8529db51edd7011d613c2ea8.png";